import classNames from "classnames";
import { useElectronAPI } from "@/react/hooks/utils/useElectronAPI";
import { BackForwardButtons } from "./BackForwardButtons";
import { useHeaderBorderStyles } from "./useHeaderColors";

export interface NavigationHistoryBarProps {
  className?: string;
}

export const NavigationHistoryBar = ({
  className,
}: NavigationHistoryBarProps) => {
  const styles = useHeaderBorderStyles();
  const { isMacOS } = useElectronAPI();
  return (
    <nav
      data-testid="navigation-history-bar"
      className={classNames(
        "border-primary bg-c-header z-[51] flex h-[2.5rem] shrink-0 items-center justify-between border-b px-4",
        className,
      )}
      style={styles}
    >
      <div
        className={classNames("flex items-center", {
          "ml-[3.4375rem]": isMacOS,
          "ml-[0.75rem]": !isMacOS,
        })}
      >
        <BackForwardButtons />
      </div>
      <div
        className="electron-draggable-element mr-[40px] flex size-full items-center"
        data-testid="navigation-history-bar-actions"
      />
    </nav>
  );
};
